import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Input from '@material-ui/core/Input';
import 'date-fns';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie'
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class ChangePasswordDialog extends React.Component {
  state = {
    loading: false,
    showPassword1: false,
    showPassword2: false,
    showPassword3: false,
    old_pw: "",
    pw: "",
    pw_repeat: "",
    error_message: "",
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleClickShowPassword = (name, value) => {
    this.setState({ [name]: value });
  }

  onReset = () => {
    this.setState({ old_pw: "", pw: "", pw_repeat: "", showPassword1: false, showPassword2: false, showPassword3: false, loading: false, initializing: false });
  }

  changePassword = () => {
    if (this.state.old_pw.length > 0 && this.state.pw.length > 0 && this.state.pw_repeat.length > 0) {
      if (this.state.pw === this.state.pw_repeat) {
        this.setState({ loading: true });
        var currentComponent = this;
        let sha1 = require('sha1');
        request.post(Constants.BACKEND_URL)
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('accept', 'json')
          .send({ command: (this.props.leader ? "changepasswordleader" : "changepassword"), parent_id: currentComponent.props.parentId, old_pw: sha1(this.state.old_pw), pw: sha1(this.state.pw) })
          .end((err, res) => {
            var result = res.text.trim();
            if (result === "1") {
              if (currentComponent.props.cookies.get("staySignedIn") !== null && !this.props.leader) currentComponent.props.cookies.set('staySignedIn', { email: currentComponent.props.cookies.get("staySignedIn").email, pw: sha1(this.state.pw) });
              this.onClose();
            } else {
              currentComponent.setState({ snackbar_open: true, error_message: "Aktuelles Passwort falsch.", loading: false });
            }
          });
      } else {
        this.setState({ snackbar_open: true, error_message: "Passwörter stimmen nicht überein." });
      }
    } else {
      this.setState({ snackbar_open: true, error_message: "Es sind nicht alle Felder ausgefüllt." });
    }
  }

  onClose = () => {
    this.onReset();
    this.props.onClose();
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.changePassword();
      ev.preventDefault();
    }
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false });
  }

  render() {
    const { classes, fullScreen } = this.props;

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open} maxWidth="xs">
        <DialogTitle>{"Passwort ändern"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          {/* Altes Passwort */}
          <FormControl style={{ width: "100%", marginTop: -10 }}>
            <InputLabel htmlFor="password">Aktuelles Passwort</InputLabel>
            <Input
              label="Passwort"
              value={this.state.old_pw}
              onChange={this.handleChange('old_pw')}
              type={this.state.showPassword1 ? 'text' : 'password'}
              autoComplete="current-password"
              error={this.state.error_old_pw}
              autoFocus
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => this.handleClickShowPassword("showPassword1", !this.state.showPassword1)}>{this.state.showPassword1 ? <Visibility /> : <VisibilityOff />}</IconButton>
                </InputAdornment>
              }
              onKeyPress={this.onEnterPressed}
              required />
          </FormControl>
          <Divider />
          {/* Neues Passwort */}
          <FormControl style={{ width: "100%", marginTop: 10 }}>
            <InputLabel htmlFor="password">Neues Passwort</InputLabel>
            <Input
              label="Passwort"
              value={this.state.pw}
              onChange={this.handleChange('pw')}
              type={this.state.showPassword2 ? 'text' : 'password'}
              autoComplete="new-password"
              error={this.state.error_pw}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => this.handleClickShowPassword("showPassword2", !this.state.showPassword2)}>{this.state.showPassword2 ? <Visibility /> : <VisibilityOff />}</IconButton>
                </InputAdornment>
              }
              onKeyPress={this.onEnterPressed}
              required />
          </FormControl>
          {/* Neues Passwort wiederholen */}
          <FormControl style={{ width: "100%", marginTop: 10 }}>
            <InputLabel htmlFor="password">Neues Passwort bestätigen</InputLabel>
            <Input
              label="Passwort"
              value={this.state.pw_repeat}
              onChange={this.handleChange('pw_repeat')}
              onKeyPress={this.onEnterPressed}
              type={this.state.showPassword3 ? 'text' : 'password'}
              autoComplete="new-password"
              error={this.state.error_pw_repeat}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => this.handleClickShowPassword("showPassword3", !this.state.showPassword3)}>{this.state.showPassword3 ? <Visibility /> : <VisibilityOff />}</IconButton>
                </InputAdornment>
              }
              required />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onClose} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.changePassword} variant="contained" disabled={this.state.loading} color="primary">
            Passwort ändern
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                {this.state.error_message}
              </span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

ChangePasswordDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  leader: PropTypes.bool.isRequired,
  parentId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withMobileDialog()(withCookies(withStyles(styles, { withTheme: true })(ChangePasswordDialog)));
